
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";

const blogPosts = [
  {
    id: 1,
    title: "The Future of ERP Solutions in 2024",
    excerpt: "Discover how AI and cloud technology are transforming ERP systems.",
    date: "March 15, 2024",
    image: "photo-1488590528505-98d2b5aba04b",
    category: "Technology"
  },
  {
    id: 2,
    title: "Maximizing Business Efficiency with CRM",
    excerpt: "Learn how modern CRM solutions can boost your business productivity.",
    date: "March 10, 2024",
    image: "photo-1486312338219-ce68d2c6f44d",
    category: "Business"
  },
  {
    id: 3,
    title: "Digital Transformation in Education",
    excerpt: "How school management systems are revolutionizing education.",
    date: "March 5, 2024",
    image: "photo-1581091226825-a6a2a5aee158",
    category: "Education"
  },
  {
    id: 5,
    title: "The Impact of 5G on Business Operations",
    excerpt: "How 5G technology is revolutionizing business operations and creating new opportunities.",
    date: "February 25, 2024",
    image: "photo-1451187580459-43490279c0fa",
    category: "Technology"
  }
];

const LatestNews = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-orange-50 to-white dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent">
          Latest News & Insights
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {blogPosts.map((post) => (
            <Link 
              to={`/blog/${post.id}`} 
              key={post.id} 
              className="block transform hover:scale-105 transition-all duration-300 animate-fade-in"
            >
              <Card className="h-full overflow-hidden curved-xl border-orange-100 dark:border-gray-700 hover:shadow-xl transition-shadow duration-300">
                <div className="aspect-video overflow-hidden">
                  <img
                    src={`https://images.unsplash.com/${post.image}?auto=format&fit=crop&w=800&q=80`}
                    alt={post.title}
                    className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <CardHeader className="p-4">
                  <Badge className="mb-2" variant="outline">{post.category}</Badge>
                  <CardTitle className="text-lg text-foreground hover:text-orange-600 transition-colors duration-300">
                    {post.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4 pt-0">
                  <p className="text-muted-foreground text-sm mb-4">{post.excerpt}</p>
                  <p className="text-xs text-orange-600 dark:text-orange-400">{post.date}</p>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link to="/blog">
            <button className="px-6 py-2 bg-gradient-to-r from-orange-600 to-pink-600 text-white rounded-full hover:from-orange-700 hover:to-pink-700 transition-all duration-300">
              View All Articles
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LatestNews;
